import script from "./MetaKoronaView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaKoronaView.vue?vue&type=script&setup=true&lang=js"

import "./MetaKoronaView.vue?vue&type=style&index=0&id=71719692&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71719692"]])

export default __exports__